import styled from '@emotion/styled';

import { lightenDarkenColor } from 'utils/colors';

import vars from 'theme/styles/vars';

export default styled.div`
    width: 100%;

    textarea {
        width: 100%;
        min-height: 15em;
        border: none;
        padding: 1em 1em;
        border-radius: .5em;
        color: ${vars.colorTextDark};
        font-size: .9em;

        &::placeholder {
            color: ${lightenDarkenColor(vars.colorPrimaryLight, -100)};
        }

        &:disabled {
            background-color: #d7e2e4;
        }

        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        /* Firefox */
        &[type=number] {
            -moz-appearance: textfield;
        }
    }

    &.decorator-left {
        textarea {
            padding-left: 2.5em;
        }
    }
    &.decorator-right {
        textarea {
            padding-right: 2.5em;
        }
    }

    @media all and (max-width: ${vars.mobileL}) {
        textarea {
            font-size: 1.1em;
        }
    }
`;
